import { createActions } from 'redux-actions';

export const actions = createActions({
  API_CLIENTS_PAGE: {
    CLEAR: () => {},
  },
}).apiClientsPage;
